// extracted by mini-css-extract-plugin
module.exports = {"main":"Breadcrumb_main__0UtWQ","breadcrumbTrail":"Breadcrumb_breadcrumbTrail__rrJAs"};